module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sshet-basic-details"
    }
  }, [(_vm.modal) ? _c('mai-modal', {
    attrs: {
      "title": this.cloneTitle
    },
    on: {
      "close": function($event) {
        _vm.modal = false
      }
    }
  }, [_c('copy-descriptor', {
    ref: "cloneSpreadsheet",
    attrs: {
      "slot": "content",
      "main-id": this.main,
      "parent-id": this.parent,
      "type": this.type
    },
    on: {
      "close": function($event) {
        _vm.modal = false
      },
      "enableSave": _vm.toggleCloneSave
    },
    slot: "content"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    class: _vm.cloneSaveCss,
    on: {
      "click": function($event) {
        return _vm.$refs.cloneSpreadsheet.go()
      }
    }
  }, [_vm._v("\n        Save\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "shadow clearfix"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewing === 'all'),
      expression: "viewing === 'all'"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "btn btn-success sq",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.displayCloneButton),
      expression: "this.displayCloneButton"
    }],
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.popup
    }
  }, [_vm._v("Copy From")])]), _vm._v(" "), _c('vue-table', {
    attrs: {
      "tableData": _vm.details,
      "tableTitle": _vm.tableTitle,
      "showEdit": true,
      "showDelete": true,
      "fields": _vm.fields
    },
    on: {
      "table-edit-request": _vm.updateActive,
      "table-delete-request": _vm.doDelete
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "btn btn-success sq",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.displayCloneButton),
      expression: "this.displayCloneButton"
    }],
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.popup
    }
  }, [_vm._v("Copy From")])])], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1985fed6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/SpreadsheetDescriptor/TariffDetails.vue
// module id = 2108
// module chunks = 1